/* eslint-disable max-len */
/* eslint-disable max-lines */
export const language = {
    en: {
        administration: {
            cashflowForecasting: {
                applyModel: "Apply Model",
                applyModelByFundGridHeaders: {
                    assetClass: "Asset Class",
                    commitment: "Commitment",
                    commitmentDate: "Commitment Date",
                    fundName: "Fund Name",
                    geography: "Geography",
                    investorAccName: "Investor Account Name",
                    model: "Model",
                    source: "Source",
                    strategy: "Strategy"
                },
                applyModelsByFund: "Apply Models by Fund",
                custom: "Custom",
                customModels: {
                    addCustomModelContent: "Create model based on",
                    addCustomModelTitle: "Add Custom Model",
                    addCustomModelTypeExcel: "Import from Excel",
                    associatedFunds: "Associated Funds (investors)",
                    associatedObjectives: "Associated Objectives (portfolios)",
                    cannotDeleteModelMessage: "This model cannot be deleted becaue it is still used.",
                    deleteModelMessage: "Deletion of model cannot be undone.",
                    deleteModelTitle: "Are you sure you want to delete this model?",
                    importValidationErrors: {
                        diffModelName: "Model name should be the same",
                        emptyCashFlows: "Excel document can't be loaded or missing cashflows",
                        errorLabel: "Cashflow Model Errors",
                        invalidAsOfDate: "As of date isn't valid",
                        numberFormat: "Contributions, Distributions, NAV preview should be valid numbers",
                        wrongModelName: "Model name can contains only letters, numbers, underscore and dash",
                        yearsAndQuaters: "Columns Year and Quarter must have continuity"
                    },
                    modelTypeImported: "Imported",
                    modelTypeTaParameters: "Custom Parameters",
                    userModelInspection: {
                        applicableFromDeprecated: "As of Date (deprecated)",
                        applicableFromDeprecatedDescription: "As of Date is deprecated and will be removed in the future",
                        asOfDate: "As of Date",
                        commitment: "Commitment",
                        configureTab: {
                            cashflowCurve: "Cashflow Model",
                            configure: "Configure",
                            exportToExcel: "Export to Excel",
                            importFromExcel: "Import from Excel"
                        },
                        createNew: "Create new model",
                        description: "Description",
                        editOrUpdateMessage: "Would you like to create a new model or update existing one?",
                        editOrUpdateTitle: "'Model Name' was changed",
                        exportQuestion: "There are unsaved changes. Do you want to save changes first or export without those changes?",
                        exportWithoutChanges: "Export without changes",
                        historyTab: {
                            heading: "Versions of this model",
                            history: "History"
                        },
                        inceptionToDateTvpi: "Inception-to-date TVPI",
                        lifetime: "Lifetime (years)",
                        modelName: "Model Name",
                        newModel: "New model",
                        prepopulate: "Prepopulate with default model",
                        previewTab: {
                            preview: "Preview"
                        },
                        update: "Update model"
                    }
                },
                default: "Default",
                errorMessages: {
                    percentError: "Value should be a percent value between 0 and 100",
                    positiveNumberError: "Value should be a positive number"
                },
                predefined: "Predefined",
                restoreToDefault: "Restore to Default",
                showExceptionsOnly: "Show exceptions only",
                taModels: {
                    Bow: "Bow Factor",
                    GrowthRate: "Growth Rate",
                    MinDistributionRate: "Min Distribution Rate",
                    assetClass: "Asset Class",
                    cashflows: "Cashflows",
                    cffModel: "CFF Model",
                    constituents: "Constituents",
                    contributionMeanFit: "Contribution Mean Fit",
                    contributionRate: "Contribution Rate",
                    contributions: "Contributions",
                    description: "Description",
                    distributionMeanFit: "Distribution Mean Fit",
                    distributions: "Distributions",
                    getYear: (yearNum) => `Year ${yearNum}`,
                    lastUpdated: "Last Updated",
                    modelTransparency: {
                        cashflowModel: "Cashflow Model",
                        contribution: "Contribution",
                        distribution: "Distribution",
                        meanContributionFit: "Mean Contribution Fit",
                        meanDistributionFit: "Mean Distribution Fit",
                        meanNavFit: "Mean NAV Fit",
                        modelTransparency: "Model Transparency",
                        nav: "NAV",
                        numberOfConstituents: "No. of Constituents",
                        observed: "Observed",
                        p10: "10th",
                        p25: "25th",
                        p50: "50th",
                        p75: "75th",
                        p90: "90th",
                        predicted: "Predicted",
                        preview: "Preview",
                        subtitle: "Evaluate model constituency, fit, and performance for the underlying parameters"
                    },
                    nav: "NAV",
                    navMeanFit: "NAV Mean Fit",
                    recalculate: "Recalculate",
                    strategy: "Strategy"
                },
                unsavedChanges: "You have unsaved changes, are you sure you want to leave this page?"
            },
            dataAdministration: {
                exportData: {
                    assets: {
                        assetType: "Type",
                        country: "Country",
                        currency: "Currency",
                        name: "Name",
                        sector: "Sector"
                    },
                    columns: {
                        description: "Description",
                        exportDate: "Export Date",
                        name: "Export Name"
                    },
                    export: "Export",
                    exportTypes: {
                        assets: "Assets",
                        funds: "Funds",
                        investorAccounts: "Investor Accounts",
                        managers: "Managers",
                        portfolio: "Portfolios",
                        submissions: "Submissions"
                    },
                    funds: {
                        currency: "Currency",
                        geography: "Geography",
                        manager: "Manager",
                        name: "Name",
                        size: "Size",
                        strategy: "Strategy",
                        vintageYear: "Vintage Year"
                    },
                    history: "History",
                    investorAccounts: {
                        fundCurrency: "Fund Currency",
                        fundGeography: "Fund Geography",
                        fundName: "Fund Name",
                        fundStrategy: "Fund Strategy",
                        investorAccount: "Investor Account",
                        investorCurrency: "Investor Currency",
                        vintageYear: "Vintage Year"
                    },
                    label: "Export Data",
                    managers: {
                        assetsUnderManagement: "Assets Under Managemet",
                        country: "Country",
                        currency: "Currency",
                        name: "Name"
                    },
                    modalTitle: "Export Data",
                    portfolios: {
                        aladdinTicker: "Aladdin Portfolio Ticker",
                        currency: "Currency",
                        name: "Name"
                    },
                    selectionLabel: "Export data from"
                },
                importData: {
                    columns: {
                        description: "Description",
                        details: "Details",
                        download: "Download",
                        importDate: "Import Date",
                        importName: "Import Name",
                        status: "Status"
                    },
                    downloadTemplate: "Download Template",
                    label: "Import Data",
                    manageData: {
                        deleteButton: "Delete Data",
                        deleteConfirmation: "Are you sure you want to delete this imported data? Once deleted, it will no longer be accessible and will need to be re-uploaded. ",
                        deleteError: "Errored out while deleting data.",
                        deletePending: "Data deletion in progress...",
                        deleteSuccess: "Data Successfully deleted.",
                        modalHeader: "Delete Import Data",
                        modalText: "You can permanently delete all data for this imported file from platform. Once this action has been completed it cannot be undone.",
                        title: "Delete Imported Data"
                    },
                    modalTitle: "Import Data from Excel",
                    question: {
                        first: "first.",
                        notSureWhatToImport: "Not sure what to import?"
                    },
                    refresh: "Refresh",
                    uploadFile: "Import Data from Excel",
                    uploadStatus: {
                        error: "Errored out",
                        inProgress: "In Progress",
                        submitted: "Submitted",
                        success: "Completed"
                    }
                },
                pages: "Pages"
            },
            marketDataAdministration: {
                indices: {
                    defaultInsightResearchSource: "Insight Research",
                    defaultStatisticsByPercentileType: "Statistics by percentile",
                    deleteConfirmationMessage: "Delete selected index?",
                    deleteHeader: "Delete managed index",
                    equityBenchmarksTabs: {
                        standard: "Standard",
                        uploaded: "Uploaded"
                    },
                    equityIndices: {
                        exportIndices: "Export Indices",
                        importIndices: "Import Indices"
                    },
                    equityIndicesTabs: {
                        defaultIndices: "Default Indices",
                        managedIndices: "Managed Indices"
                    },
                    importValidationErrors: {
                        dialogTitle: "Import Index Errors",
                        duplicateIndex: (rowNumber) => `Duplicate Index Name: row ${rowNumber}`,
                        duplicatePriceData: (rowNumber) => `Duplicate Price Data: row ${rowNumber}`,
                        duplicateTicker: (rowNumber) => `Duplicate Ticker Name: row ${rowNumber}`,
                        emptyFileOrNoIndex: "Excel document can not be loaded or there are missing indices",
                        missingCurrency: (rowNumber) => `Missing Index Currency: row ${rowNumber}`,
                        missingIndex: (rowNumber) => `Missing Index Name: row ${rowNumber}`,
                        missingPriceData: (rowNumber) => `Missing Price Data: row ${rowNumber}`,
                        missingTicker: (rowNumber) => `Missing Ticker: row ${rowNumber}`
                    },
                    indices: "Indices",
                    otherStrategyType: "All",
                    privateEquityBenchmarks: {
                        actionCannotBeUndone: "This action cannot be undone.",
                        deleteConfirmation: (name) => `Are you sure you want to delete Benchmark "${name}"?`,
                        deleteHeader: "Delete Private Benchmark",
                        downloadTemplate: "Download Template",
                        exportBenchmarks: "Export Benchmarks",
                        exportLastQuarter: "Export Last Quarter",
                        headerNames: {
                            numberOfFunds: "Number Of Funds",
                            referenceDate: "Reference Date"
                        },
                        importBenchmarks: "Import Benchmarks",
                        importStatus: {
                            benchmarkImported: (nb) => `${nb} benchmark${nb > 1 ? "s" : ""} had been successfully imported`,
                            failure: "Import failed",
                            information: "Information",
                            noBenchmarks: "No benchmarks were found to import",
                            success: "Success"
                        },
                        preqinExportBlockedTooltip: "A Preqin Pro subscription is required to export Preqin benchmarks.",
                        title: "Private Market Benchmarks"
                    },
                    publicMarketIndices: "Public Market Indices",
                    zeroVintageType: "All"
                }
            }
        },
        analyticsAssistant: {
            addToDashboard: {
                buttonCurrentDashboardTitle: "Add to Current Dashboard",
                buttonTitle: "Add to Dashboard",
                chooseAnalysis: "Choose an Analysis",
                chooseSection: "Choose a Section",
                noCustomAnalysis: "No custom analysis found..."
            },
            chatMessageEntry: {
                additionalActions: "Additional Actions",
                suggestedQuestion: "Suggested Question"
            },
            errorOccured: "An error occured. Please contact support or try again later.",
            exportToExcel: {
                buttonLabel: "Download data as Excel"
            },
            loadHistory: "Load history...",
            messagePlaceholder: "Type your question",
            questionOutOfScope: "I did not understand the question. Can you rephrase it, please?",
            questionsExamples: {
                firstQuestion: "What is the TVPI of my portfolio?",
                secondQuestion: "Can I see the evolution of IRR over time?",
                title: "Question Examples"
            },
            sendMessageInProgress: "Sending message...",
            serverError: "An error occured - please try again later",
            shortTitle: "Chat",
            startOverButtonCaption: "Start over",
            termsAndConditions: {
                // eslint-disable-next-line max-len
                disclaimerMessage: "**Disclaimer:** You are chatting with eFront Copilot, an AI-powered chatbot. The purpose of eFront Copilot is to help you consult your eFront Insight data more efficiently and to present it in easily digestible formats, such as widgets, charts, KPIs or tables. It is not moderated or checked by human reviewers, and its output may contain errors, inaccuracies, or biases, so please verify all the relevant information with other sources before using it or relying upon it. eFront Copilot does not and is not intended to provide professional or investment advice and should not be relied upon for investment decisions or for any other similar purpose. Please do not enter any proprietary, confidential or personal information (including individuals' names) when asking the eFront Copilot chatbot questions, unless we are authorized to access such information under our agreement with you and such information is necessary for us to provide you with eFront Insight.\n" +
                    "\n" +
                    // eslint-disable-next-line max-len
                    "Note that eFront Copilot is not intended to be used to report outages of the eFront Insight platform. To report an outage or request support relating to eFront Insight, please follow the standard incident ticketing process or reach out to your relationship manager.\n" +
                    "\n" +
                    // eslint-disable-next-line max-len
                    "eFront Copilot collects logon ID solely for telemetry purposes, while anonymized logs and chat messages are collected for product improvement purposes to help us enhance our service and provide better experience for users. Anonymized logs and chat messages are retained for a period of life of eFront Insight plus three years. For further information on Privacy and Data Protection, please find our Client and Vendor Privacy Notice [here](https://www.blackrock.com/corporate/compliance/privacy-policy). For inquiries with regards to eFront Copilot, contact your relationship manager.\n" +
                    "\n" +
                    "eFront Copilot is made subject to the terms of your agreement with BlackRock or its affiliates with respect to the provision of data or technology services.\n"
            },
            title: "Chat",
            welcomeMessageSubtitle: "To view data for this portfolio in a table or chart, just ask below",
            welcomeMessageTitle: "Hello, how can I help you?"
        },
        assetClass: {
            gridTitle: "Asset Class",
            infra: "Infrastructure",
            pd: "Private Debt",
            pe: "Private Equity",
            re: "Real Estate"
        },
        assets: {
            dealsSelectorTitle: "Fund",
            gridTitle: "Assets"
        },
        authentication: {
            failed: "Authentication failed",
            tryAgain: "Try Again",
            unableToLoad: "Unable to load your account. Please contact support or try again later."
        },
        browserCompatibility: {
            infoAppNotCompatibleWithBrowser: "This application is not compatible with this browser.",
            instructionCopyLinkToSupportedBrowser: "You may also copy the link to view in a supported version of Google Chrome or Microsoft Edge.",
            instructionOpenSupportedBrowser: "Please open a supported version of Google Chrome or Microsoft Edge."
        },
        campaigns: {
            allCampaignsDisplayValue: "All",
            asOfDate: "As of Date",
            campaign: "Campaign",
            campaigns: "Campaigns",
            campaignsData: "Campaigns Data",
            campaignsOverview: "Campaigns Overview",
            details: "Campaign Details",
            detailsTemplateDownload: {
                downloadErrorMsg: "Download failed! Please try again.",
                downloadInProgressMsg: "Download in progress...",
                downloadSuccessMsg: "Download successful!",
                downloadUnavailableTooltip: "This submission is pending and cannot be downloaded."
            },
            errorMsg: "There was an error loading the campaigns data. Please try refreshing your browser window.",
            export: {
                additionalInformation: "Additional Information",
                campaignCompletion: "Campaign Completion",
                campaignStatusTitle: "CAMPAIGN STATUS REPORT",
                downloadAllButtonLabel: "Download Campaign Data",
                exportButtonLabel: "Excel Export",
                numberOfSubmissions: "Total no of Submissions",
                referenceDate: "Reference Date",
                reportsReceived: "Reports Received",
                summaryStatistics: "SUMMARY STATISTICS"
            },
            headerLabels: {
                campaignCompletion: "Campaign Completion",
                reportsReceived: "Reports Received",
                totalNumberOfSubmissions: "Total Number of Submissions"
            },
            quarter: "Quarter",
            submissions: "Pending Submissions",
            submissionsGrid: {
                assetClass: "Asset Class",
                availableInInsight: "Available in Insight",
                campaign: "Campaign",
                completeReportReceivedOn: "Complete Report Received On",
                compliance: "Compliance",
                description: "Description",
                download: "Download",
                firstDataAvailableInInsight: "Data Available in Insight (first)",
                fundManager: "Fund Manager",
                fundName: "Fund Name",
                lastDataAvailableInInsight: "Data Available in Insight (last)",
                reportReceivedOn: "Reports Received on",
                revalidated: "Revalidated",
                status: "Status",
                transformStatus: "Transform Status",
                validateStatus: "Validate Status"
            },
            summary: "Campaign Summary",
            summaryGrid: {
                noData: "There is no data to show for this selection. Please select a different campaign or date range.",
                numberOfSubmissions: "No of Submissions",
                percentageOfSubmissions: "% of Total submissions",
                status: "Status"
            },
            summaryLabels: {
                approved: "Approved",
                awaitingAdditionalReports: "Awaiting Additional Reports",
                cancelled: "Cancelled",
                declined: "Declined",
                pending: "Pending",
                pendingWithReports: "Pending - With Reports",
                pendingWithoutReports: "Pending - Without Reports",
                submittedForValidation: "Submitted for validation",
                validated: "Validated"
            },
            summaryPopoverLabels: {
                approved: "Data processed, validated and released to Insight platform",
                awaitingAdditionalReports: "GP reporting available but not sufficient for validation",
                cancelled: "No reporting expected for selected and subsequent reference date e.g. liquidated fund, exited position",
                declined: "No reporting expected for selected reference date e.g. semi-annual or annual reporting, new funds yet to start reporting - see details in campaign status tab",
                pendingWithReports: "GP reporting available, in processing queue",
                pendingWithoutReports: "No reporting available from GP",
                submittedForValidation: "Being processed by Insight team",
                validated: "Data processed and validated by Insight Team"
            }
        },
        chart: {
            map: {
                footerMessage: (itemCount) => `${itemCount} asset${itemCount === 1 ? " is" : "s are"} not shown on the map due to unknown city or country`,
                tooltip: {
                    companies: "Assets",
                    company: "Company",
                    country: "Country",
                    fmv: "FMV",
                    fund: "Fund",
                    repRiskRating: "RepRisk Rating",
                    status: "Status",
                    subIndustry: "Sub-Industry"
                }
            },
            scatterPlot: {
                linearRegression: "Linear Regression"
            },
            timeBasedSeries: {
                tooltip: {
                    referenceDate: "Reference Date"
                }
            },
            tooltip: {
                percentageOfTotal: "% of Total"
            }
        },
        commitmentPacing: {
            actions: {
                createNewPacingPlan: "Create New Pacing Plan",
                editSelectedPlan: "Edit Selected Plan",
                includePacingPlan: "Include Pacing Plan",
                managePacingPlan: "Manage Pacing Plan",
                seeAllPacingPlans: "See All Pacing Plans",
                selectPacingPlan: "Select Pacing Plan"
            },
            admin: {
                description: {
                    text: "Create, edit and delete your pacing plans using commitment pacing or manually entering future planned commitments",
                    title: "Pacing Plans"
                }
            },
            allocationTarget: {
                addAllocation: "Add Allocation",
                allocation: "Allocation",
                grid: {
                    cff: "Cashflow Forecast Model",
                    comments: "Comments",
                    maxAC: "Max. Annual Commitment (in millions)",
                    minAC: "Min. Annual Commitment (in millions)",
                    minInvInc: "Min. Increment Commitment (in millions)",
                    nav: "NAV Weight",
                    region: "Region",
                    sectorFocus: "Sector Focus",
                    strategy: "Strategy"
                },
                header: "Allocation Target",
                navSumLabel: (i) => `NAV Total: ${i}%`,
                popover: {
                    maxAC: "Sets a cap on the annual commitment amount in a given year.",
                    minAC: "Sets a recurring minimum annual commitment amount.",
                    // eslint-disable-next-line max-len
                    minInvInc: "Constraint on the minimum threshold of added commitment planned for a period. It should be set to the smallest commitment that would be reasonable to make to a single fund in practice.",
                    smoothnessFactor: "The smoothing factor operates on a range from 0-100 and controls the relative importance of minimizing the difference in total commitments from one year to the next."
                },
                portfolioNav: "Portfolio NAV",
                smoothnessFactor: "Smoothness Factor"
            },
            calculationResultsContent: {
                calculationResultsFailed: "Last calculation failed! Check the notifications for more details",
                calculationResultsNotReady: "Calculation results are not ready yet",
                cashflowCurvesPreview: "Cashflow Curves Preview",
                navAreaPreview: "NAV Area Preview",
                previews: "Previews",
                projectedCommitmentsPreview: "Projected Commitments Preview"
            },
            dashboardHeader: {
                calculate: "Calculate",
                createNewPacingPlan: (name) => `Create New Pacing Plan for Portfolio: ${name ?? ""}`,
                editPacingPlan: (name) => `Pacing Plan for Portfolio: ${name ?? ""}`,
                makeDefault: "Make pacing plan the default for this portfolio",
                planStartDate: "Plan Start Date",
                savePacingPlan: "Save Pacing Plan",
                title: (name) => `Commitment Pacing for Portfolio: ${name}`,
                uniqueName: "Unique Name",
                viewInPortfolio: "View in Portfolio"
            },
            default: "Default",
            header: {
                clearAll: "Clear Settings",
                deletePlan: "Delete Plan",
                objective: "Objective",
                objectives: "Objectives",
                rename: "Rename",
                saveAsNew: "Save as New",
                saveChanges: "Save Changes"
            },
            modal: {
                deleteObjectivePostMessage: "? This action can not be reversed.",
                deleteObjectivePreMessage: "Are you sure you want to delete Objective ",
                deleteObjectiveTitle: "Delete Selected Objective?",
                descriptionInput: "Description",
                inputPlaceholder: "Input text",
                nameInput: "Name",
                newObjectiveTitle: "Save New Objective",
                saveChangesConfirmationPostMessage: "?",
                saveChangesConfirmationPreMessage: "Do you want to save the changes you made to ",
                saveChangesConfirmationPrimaryButton: "Yes, save over existing",
                savePacingPlanConfirmationTitle: "Save Pacing Plan",
                savePlanConfirmationPostMessage: "?",
                savePlanConfirmationPreMessage: "Do you want to save the pacing plan ",
                savePlanConfirmationPrimaryButton: "Yes, save plan",
                updateObjectiveTitle: "Update Objective"
            },
            objectiveSaveMessage: {
                failed: "Objective Save Failed.",
                success: "Objective Saved Successfully."
            },
            objectiveSettingsContent: {
                addTargetNAV: "Add Target NAV",
                defaultCalculateNavTargetValue: "20 years",
                longTermBeginYear: "Long Term begins at Year",
                longTermGrowthRate: "Long-term Growth Rate",
                minCumulativeNetCashflows: "Min. Cumulative Net Cashflow (in millions)",
                popover: {
                    longTermBeginYear: "Start of the long term period, allowing a change in the projected NAV growth rate.",
                    longTermGrowthRate: "Growth rate of the projected NAV after the start of the long-term period, as defined in the \"Long Term Begins At Year\" parameter.",
                    shortTermGrowthRate: "Growth rate of the projected NAV before the start of the long-term period, as defined in the \"Long Term Begins At Year\" parameter."
                },
                portfolioTargetNav: "NAV Target",
                previewNAVTargets: "Preview: NAV Targets",
                relaxLiquidityConstraints: "Relax Liquidity Constraints",
                setTargetNAVEachYear: "Target NAVs ( in millions)",
                settings: "Settings",
                shortTermGrowthRate: "Short-term Growth Rate",
                yearX: (i) => `Year ${i}`
            },
            tabs: {
                calculationResults: "Calculation Results",
                objectiveSettings: "Objective Settings"
            },
            validationErrorDialog: {
                invalidNavSum: "Please make sure tha NAV total is 100%",
                minMaxRule: "Please make sure that Maximum Annual Commitment is greater than Minimum non-zero commitment",
                noDuplicateYears: "Please make sure that there are no duplicate years",
                requiredFields: "Please set all required fields",
                title: "Objective Settings Errors"
            },
            widget: {
                previewNavTargetsConstants: {
                    currentNav: "Current NAV",
                    longTerm: "Long Term",
                    projectedNav: "Projected NAV",
                    targetNav: "Target NAV",
                    xAxisTitle: "Years",
                    yAxisTitle: "In Millions"
                },
                previewPortfolioWeightTargetChart: {
                    currentTarget: "Current Target",
                    newTarget: "New Target",
                    region: "Region",
                    sectorFocus: "Sector Focus",
                    strategy: "Strategy",
                    title: "Preview: Portfolio Weight Target"
                }
            }
        },
        common: {
            add: "Add",
            back: "Back",
            by: "by",
            cancel: "Cancel",
            close: "Close",
            copy: "Copy",
            copyLink: "Copy Link",
            create: "Create",
            delete: "Delete",
            discard: "Discard",
            download: "Download",
            downloadSelectedDocuments: "Download selected documents",
            downloading: "Downloading...",
            downloadingProgress: (completed, total) => `Downloading ZIP ${completed}/${total}`,
            duplicate: "Duplicate",
            edit: "Edit",
            enterTextHere: "Enter text here",
            export: "Export",
            hide: "Hide",
            next: "Next",
            no: "No",
            nodata: "No data available",
            ok: "Ok",
            preqin: "Preqin",
            redo: "Redo",
            refresh: "Refresh",
            repRiskRating: "RepRisk Rating",
            reset: "Reset",
            rowStriping: "Row striping",
            save: "Save",
            saveAll: "Save All",
            saveAsNew: "Save As Custom",
            seeBenchmark: "See Full benchmark",
            set: "Set",
            share: "Share",
            source: "Source",
            titles: {
                asset: "Asset",
                assets: "Assets",
                base: "eFront Insight",
                campaigns: "Campaigns",
                cashflowForecasting: "Cashflow Forecasting",
                customIndices: "Custom Indices",
                data: "Data",
                documentService: "Document Service",
                fund: "Fund",
                fundSeries: "Fund Series",
                funds: "Funds",
                jCurves: "J-Curves",
                manager: "Manager",
                managers: "Managers",
                market: "Market",
                marketData: "Market Data",
                marketMap: "Market Map",
                markets: "Markets",
                notes: "Notes",
                pacingPlans: "Pacing Plans",
                peerComparison: "Peer Investor Comparison",
                permissions: "Permissions",
                portfolio: "Portfolio",
                portfolios: "Portfolios",
                research: "Research"
            },
            total: "Total",
            undo: "Undo",
            upload: "Upload",
            view: "View",
            viewDetails: "View details",
            yes: "Yes"
        },
        dashboard: {
            actionBar: {
                runMode: {
                    download: {
                        downloadAssetCashflows: "Export Assets Cashflows to Excel",
                        downloadFundCashflows: "Export Fund Cashflows to Excel",
                        downloadFundsCashflows: "Export Funds Cashflows to Excel",
                        downloadInvestorsCashflows: "Export Investors Cashflows to Excel",
                        downloadPdf: "Export Analysis to PDF",
                        exportDataset: "Export Dataset",
                        exportLayoutMenuItem: "Export to PDF",
                        viewFundCashflows: "View Fund Cashflows",
                        viewFundsCashflows: "View Funds Cashflows",
                        viewInvestorsCashflows: "View Investors Cashflows"
                    }
                }
            },
            addAnalysis: "Add Analysis",
            addPage: "Add Page",
            addingAnalysisMsg: "Adding analysis...",
            analysis: "Analysis",
            asOfDate: "As of",
            cashflowDescription: "Forecast existing portfolios and overlay pacing plans to project cashflows of potential future investments",
            cffChangeModal: {
                applyModelToFund: "Apply Model",
                cancel: "Cancel",
                editCalibrationsInAdmin: "Edit Calibrations in Admin",
                existingModel: "Existing Model",
                modelComparison: (fundName) => `Model Comparison for ${fundName}`,
                newModel: "New Model",
                noDataAvailable: "No data available",
                tabs: {
                    contributions: "Contributions",
                    distributions: "Distributions",
                    nav: "NAV",
                    netCashflow: "Net Cashflow"
                },
                title: (fundName) => `Review and Change Model for ${fundName}`,
                underlyingModelData: (modelName) => `Model Transparency for ${modelName}`
            },
            commitmentPacing: "Commitment Pacing",
            compare: "Compare with...",
            currency: "Currency",
            deletionAnalysisMsg: "Deleting analysis...",
            duplicateAnalysisMsg: "Duplicating analysis...",
            edit: {
                addColumns: "Add Columns",
                addDefaultGroups: "Add Default Groups",
                addGroup: "Add Group",
                addMeasure: "Add Measure",
                addToPage: "Add To Page",
                addWidget: "Add Widget",
                closeEditor: "Close Editor",
                createCustomWidget: "Create Widget",
                createWidget: "Create Widget",
                defaultPreviewMessage: "The preview will appear here",
                delete: "Delete Analysis",
                deleteAnalysis: "Delete Analysis ?",
                deleteAnalysisMsg: (name, isDefault) => (isDefault
                    ? `Are you sure you want to hide ${name}? You can unhide the analysis from the Layout Settings in your General Settings menu.`
                    : `Are you sure you want to delete ${name}? `),
                duplicate: "Duplicate",
                duplicateAsType: (type) => `Duplicate as ${type}`,
                edit: "Edit",
                editAnalysis: "Edit Analysis",
                editAnalysisNameLabel: "Analysis Name",
                editPageNameLabel: "Page Name",
                editSectionNameLabel: "Section Name",
                editWidget: "Edit Widget",
                groupWidgetTitle: "Grouped Widget",
                hideAnalysis: "Hide Analysis ?",
                investmentType: "Investment Type",
                moveDown: "Move down",
                moveUp: "Move up",
                rename: "Rename",
                selectAWidget: "Please, select a widget",
                sources: "Sources",
                tags: "Tags",
                unsavedChanges: "Changes you made will be lost",
                unsavedChangesHeader: "Unsaved Changes",
                widgetAdded: "Widget Successfully Added",
                widgetType: "Widget Type"
            },
            editLayout: "Edit Layout",
            editPortfolio: "Edit",
            errorMessages: {
                entityNotFoundError: (entityType) => `${entityType} cannot be opened`
            },
            esgSource: {
                label: "ESG Source:",
                labelRepRiskDocumentation: "RepRisk Documentation",
                labelRepRiskESGDataScience: "RepRisk ESG Data Science",
                learnMore: "Learn more:",
                repRisk: "RepRisk"
            },
            filter: "Filter",
            filters: "Filters",
            filtersDate: (starDate, endDate) => `From ${starDate} to ${endDate}`,
            includeHistorical: "Include Historical Cashflows",
            loadingAnalysis: "Loading analysis...",
            myPositions: "My positions only",
            myPositionsTooltip: {
                commitment: "Commitment-based calculation is applied",
                grossNav: "Gross NAV-based calculation is applied",
                grossNavHybrid: "Gross NAV-based calculation is applied to unrealized positions, while commitment-based calculation is applied to realized positions",
                hybrid: "Net NAV-based calculation is applied to unrealized positions, while commitment-based calculation is applied to realized positions",
                nav: "Net NAV-based calculation is applied"
            },
            noDateSet: "no date set",
            overview: "overview",
            pdfExport: {
                analysisPages: "Analysis Pages",
                custom: "20mm",
                default: "3mm",
                downloadPdf: "Export to PDF",
                downloadPdfAnalysis: "Export Analysis to PDF",
                downloadPdfFailed: "PDF export failed!",
                downloadPdfSection: "Export Section to PDF",
                downloadPdfStarted: "PDF export started. You will be notified when the document is ready for download!",
                frontAndBackPages: "Front & Back Pages",
                hideBackPage: "Hide Back Page",
                hideFrontPage: "Hide Front Page",
                horizontal: "Horizontal",
                landscape: "Landscape",
                orientation: "Orientation",
                pageMargins: "Page Margins",
                pageOptions: {
                    hideBackPage: "Hide Back Page",
                    hideFrontPage: "Hide Front Page",
                    horizontal: "Horizontal",
                    margins: "Margins",
                    orientation: "Orientation",
                    paperSize: "Paper size",
                    vertical: "Vertical"
                },
                pageSize: "Page Size",
                pageWidth: "Page Width",
                pageWidthCurrent: "Current window",
                pageWidthFullHD: "Full HD",
                pageWidthQuadHD: "Quad HD, 2K",
                pageWidthUltraHD: "Ultra HD, 4K",
                portrait: "Portrait",
                printLabel: "Print",
                printOptimized: "Print Optimized",
                printOptimizedInfo: "Best suited for data export and print on paper",
                progressTitle: "Exporting to PDF",
                screenLabel: "Screen",
                screenOptimized: "Screen Optimized",
                screenOptimizedInfo: "Best suited for viewing content on screen",
                unoptimizedPageMessage: "This page is not optimized for print. For optimal PDF export, use print optimized page.",
                vertical: "Vertical"
            },
            select: "Select analysis:",
            settingsMenu: {
                resetBenchmark: "Reset Benchmark",
                runRiskCalculation: {
                    errorMessage: "Something went wrong. Risk Recalculation failed.",
                    label: "Run Risk Calculation",
                    pendingMessage: "The message is being sent...",
                    successfulMessage: "Message sent."
                },
                setBenchmark: "Set Benchmark",
                setCffModel: "Set CFF Model",
                setComparison: "Set Comparison",
                setPMIs: "Set Public Indices",
                settings: "Settings"
            },
            timePeriod: {
                calculationPeriodTooltip: "Controls the historical period used to calculate performance metrics such as IRR and TWR.",
                dataGranularity: "Data Granularity",
                dataGranularityTooltip: {
                    description: "Controls the frequency of the data observations in widgets. It does not impact any underlying calculations.",
                    quarterly: "Quarterly: Displays one observation for each calendar quarter, using the quarter end date.",
                    yearOverYear: "Year over Year: Displays one observation for each calendar year, based on the as of date.",
                    yearly: "Yearly: Displays one observation for each calendar year, using the year end date."
                },
                displayText: {
                    displayFromPeriodText: (period) => `${period} to Date`,
                    displayFromToDateText: (fromDate, toDate) => `${fromDate} \u2013 ${toDate}`,
                    displayLastPeriodText: (period, step) => `Last ${step} ${period}`
                },
                note: "Applies to all supported widgets across all analysis pages",
                periodAndGranularity: "Period and Granularity",
                timePeriod: "Time Period",
                timePeriodTooltip: "Controls the reporting window of the displayed data in widgets. It does not impact any underlying calculations, except for Variation widgets, Total Value, and the Value Bridge."
            }
        },
        dialogs: {
            unsavedChanges: {
                content: "Changes you made will be lost.",
                title: "Unsaved changes"
            }
        },
        documentGrid: {
            documentsLimitationMessage: "Only 5000 records can be shown at the moment due to technical limitations.",
            filteredCount: "Filtered",
            gridFilters: {
                audited: "Audited",
                documentCategory: "Document Category",
                downloadedDate: "Downloaded Date",
                dueDate: "Due Date",
                fund: "Fund",
                investor: "Investor Account",
                manager: "Manager",
                metadataModificationDate: "Metadata Modification Date",
                publishedDate: "Delivery Date",
                receivedDate: "Received Date",
                referenceDate: "Reference Date",
                template: "Template"
            },
            notification: {
                downloadFailed: "Download failed!",
                downloadName: "Download Name",
                downloadPending: "Download in progress...",
                downloadSucceeded: "Download succeeded!"
            },
            selectedDocument: "Selected Rows",
            tenantTotalCount: "Total Rows"
        },
        errorBoundary: {
            developmentMessage: (errorMessage) => `Something went wrong. ${errorMessage}`,
            goToHome: "Go to home",
            message: "We're sorry, but something unexpected happened. Please try refreshing the page.",
            tryAgain: "Try again"
        },
        exceptions: {
            emptyCurrencyException: "Missing a critical datapoint : currency"
        },
        filter: {
            applyFilters: "Apply",
            clearFilters: "Clear All",
            filterBy: "Filtered by:",
            notEqual: "Not Equal",
            save: "Save Filter",
            search: "Search",
            selected: "selected",
            showSelectedOnly: "Show selected only"
        },
        fundSeries: {
            fundSeriesDeletion: {
                deleteFundSeries: "Delete Fund Series",
                deleteFundSeriesAlertFirstLine: (selectedNames) => `Are you sure you want to delete ${selectedNames} Fund Series?`,
                deleteFundSeriesAlertHeader: "Delete Selected Fund Series?",
                deleteFundSeriesAlertSecondLine: " This action can not be reversed. Once deleted, it will no longer be accessible and will need to be re-uploaded.",
                deleteFundSeriesErrorMessage: "Failed to delete Fund Series.",
                deleteFundSeriesPendingMessage: "Deleting Fund Series...",
                deleteFundSeriesSuccessMessage: "Fund Series deleted successfully."
            },
            gridHeaderField: {
                asAtDate: "As at Date",
                assetClass: "Asset Class",
                assetClasses: "Asset Classes",
                currency: "Currency",
                dateUploaded: "Date Uploaded",
                fundManager: "Fund Manager",
                fundsInSeries: "Funds in Series",
                name: "Fund Series Name",
                referenceDate: "Reference Date",
                strategy: "Strategy"
            },
            gridTitle: "Fund Series",
            listTitle: "Investment Due Diligence"
        },
        funds: {
            benchmark: {
                applyBenchmark: "Apply Benchmark",
                benchmarkingReferenceDate: "Benchmarking Reference Date",
                closeBenchmark: "Close Benchmark Settings",
                constituents: "Constituents",
                existing: "Existing",
                existingBenchmark: "Existing Benchmark",
                export: {
                    assetClass: "Asset Class",
                    columnBenchmarkName: "Benchmark Name",
                    columnFundName: "Fund Name",
                    columnInvestorName: "Investor Name",
                    entityName: "All portfolios",
                    geography: "Geography",
                    sheetName: "Benchmark Assignments",
                    strategy: "Strategy",
                    vintageYear: "Vintage Year"
                },
                exportBenchmarkConfiguration: "Export Benchmark Assignments",
                exportBenchmarkConfigurationMessageCompletedSuccessfully: "Benchmark assignment export completed",
                exportBenchmarkConfigurationMessageFailed: "Benchmark assignment export",
                exportBenchmarkConfigurationMessageStarted: "Benchmark assignment export started",
                exportBenchmarkConfigurationMessageSuccess: "Benchmarks had been successfully set",
                importBenchmerkConfiguration: "Import Benchmark Assignments",
                medianNetIrr: "Median Net IRR",
                medianTvpi: "Median TVPI",
                new: "New",
                newBenchmark: "New Benchmark",
                referenceDateNotification: {
                    description: "Select benchmark from the table below to compare to the existing benchmark assigned to the fund",
                },
                resetBenchmark: "Reset Benchmark to Default",
                resetBenchmarkAlertFirstLine: "Benchmarks for selected funds will be restored to default.",
                resetBenchmarkAlertSecondLine: "Are you sure?",
                resetBenchmarkHeader: "Reset benchmark to default?",
                reviewAndChangeBenchmark: "Review and Change Benchmark for ",
                selectBenchmarkToCompare: "Select Benchmark to Compare",
                setBenchmark: "Set Benchmark"
            },
            columns: {
                assetClass: "Asset Class",
                benchmarkName: "Benchmark Name",
                changeBenchmark: "Change Benchmark",
                commitment: "Commitment",
                contributions: "Contributions",
                currency: "Currency",
                distributions: "Distributions",
                fundCurrency: "Fund Currency",
                fundName: "Name",
                geography: "Geography",
                investorAccountName: "Investor Account Name",
                investorCurrency: "Investor Account Currency",
                investorFundName: "Fund Name",
                managerName: "Manager",
                nav: "NAV",
                remainingCommitment: "Remaining Commitment",
                strategy: "Strategy"
            },
            gridTitle: "Funds",
            investor: "Investor",
            investorAccount: "Investor Accounts"
        },
        grid: {
            addRemoveColumns: {
                header: "Add/Remove Columns",
                label: "Add/remove columns..."
            },
            excelExport: {
                downloadExcel: "Export to Excel",
                downloadExcelFailed: "Excel export failed!",
                downloadExcelForbidden: "This type of Portfolio is not synchronized with other Aladdin systems and cannot be exported.",
                downloadExcelForbiddenMultiple: "These types of Portfolios are not synchronized with other Aladdin systems and cannot be exported.",
                downloadExcelPending: "Excel export in progress...",
                downloadExcelSucceeded: "Excel export succeeded!"
            },
            excelExportSheetName: "Data Export",
            excelImport: {
                downloadExcelFailed: "Download imported data failed!",
                downloadExcelPending: "Download imported data in progress...",
                downloadExcelSucceeded: "Download imported data succeeded!"
            },
            group: "Group",
            groupBy: "Group by",
            grouped: (count) => `Grouped by ${count} field${count > 1 ? "s" : ""}`,
            groupedTopFilter: (type, count, measure) => `${type} ${count} contributor of ${measure}`,
            investorToggle: "Investor view",
            noGrouping: "No grouping applied to this view",
            openLink: "Open",
            openLinkNewTab: "Open in new browser tab",
            otherGroup: "Others",
            publicMarketIndices: {
                closeSettings: "Close Public Indices Settings",
                setPMIs: "Set Public Indices"
            },
            thenBy: "Then by"
        },
        managers: {
            gridTitle: "Managers"
        },
        markets: {
            Blended: "Blended",
            MarketBlended: "MarketBlended",
            PreqinIndex: "Preqin Index",
            RuleBased: "Rule-based",
            Standard: "Standard",
            UserDefined: "User-defined",
            gridHeaderField: {
                assetClass: "Asset Class ",
                benchmarkName: "Benchmark Name",
                createdAt: "Created On",
                createdBy: "Created By",
                currency: "Currency",
                description: "Description",
                geography: "Geography",
                marketType: "Market Type",
                numberOfFunds: "Number of Funds",
                sizeConstraint: "Size Constraint",
                source: "Source",
                status: "Status",
                strategy: "Strategy",
                vintage: "Vintage",
                vintageYear: "Vintage Year"
            }
        },
        modal: {
            addPage: {
                title: "Add New Page"
            },
            benchmarkCreation: {
                addAllocation: "Add Allocation",
                allocationTotal: "Allocation Total:",
                benchmarkDeletion: {
                    deleteBenchmark: "Delete Benchmark",
                    deleteBenchmarkAlertFirstLine: "Selected Benchmarks will be deleted. This action can not be reversed.",
                    deleteBenchmarkAlertHeader: "Delete Selected Benchmark?",
                    deleteBenchmarkErrorTitle: "Cannot Delete Benchmark"
                },
                benchmarkName: "Benchmark Name",
                description: "Description",
                errorCreationMessage: "Market creation failed",
                title: "Create Benchmark",
                titleBlended: "Create Blended Benchmark"
            },
            editjsonWidget: {
                title: "Edit configuration of widget"
            },
            exportData: {
                exportDate: "Export Date",
                exportDateTypes: {
                    customQuarter: "Custom Quarter",
                    dateRange: "Date Range",
                    fullData: "Full Data",
                    lastAvailableQuarter: "Last Available Quarter"
                },
                exportFailed: "Export failed!",
                exportName: "Export Name",
                exportPending: "Export in progress...",
                exportSucceeded: "Export succeeded!",
                from: "From",
                includeCustomFields: "Include Custom Fields",
                includeEsgData: "Include ESG Data",
                includeInvestorAccounts: "Include Investor Accounts",
                label: "Label",
                selectQuarter: "Select Quarter",
                to: "To"
            },
            importData: {
                description: "Description",
                referenceDate: "Reference Date",
                uploadMessages: {
                    uploadFailed: "Import failed!",
                    uploadPending: "Import started in background.",
                    uploadSuccess: "Import succeeded!"
                },
                uploadName: "Upload Name"
            },
            importDataLogs: {
                content: {
                    checkErrors: "(Check Errors tab for more details)",
                    column: "Column",
                    errors: "errors",
                    folder: "Folder",
                    header: "Worksheet",
                    importResult: "Import Result",
                    itemsCreated: "items created",
                    itemsDeleted: "items deleted",
                    itemsUpdated: "items updated",
                    lastRowProcessedIndex: "Last row processed index",
                    noErrors: "No errors",
                    noLogs: "No logs available - please check Errors tab",
                    row: "Row"
                },
                detailed: "Detailed Logs",
                errors: "Errors",
                manageData: "Manage Data",
                name: "View Details",
                summary: "Summary Logs",
                title: "Import Logs"
            },
            inspectData: {
                allPeriods: "All periods",
                currentPeriod: "Current period",
                details: {
                    dataType: "Data Type",
                    referenceDate: "Reference Date"
                },
                lastPeriods: (periodsNumber) => `Last ${periodsNumber} periods`,
                origin: {
                    calculated: "Calculated",
                    inspectData: "Inspect Data",
                    repRisk: "RepRisk Data",
                    reported: "Reported Data"
                },
                tabs: {
                    ActualsAndProjections: "Actuals And Projections",
                    Asset: "Asset",
                    Cashflows: "Cashflows",
                    CommitmentPacingOutputs: "Commitment Pacing Outputs",
                    FullHistory: "Full History",
                    Fund: "Fund",
                    InspectData: "Inspect Data",
                    Portfolio: "Difference",
                    PortfolioA: "Portfolio",
                    PortfolioB: "Comparison Portfolio"
                }
            },
            pacingPlanCreation: {
                createPlanButton: "Go to Create Plan",
                modalTitle: "Select a Portfolio",
                pacingPlanDeletion: {
                    deletePacingPlan: "Delete Pacing Plan",
                    deletePacingPlanAlertFirstLine: "Selected pacing plans will be deleted. This action can not be reversed.",
                    deletePacingPlanAlertHeader: "Delete Selected Pacing Plans?"
                },
                selectPortfolio: "Select Portfolio",
                title: "Create New Pacing Plan"
            },
            portfolioComparisonSelection: {
                notificationMessage: (entityName) => `Selected Portfolio will be used for comparison to ${entityName} portfolio`,
                title: "Select Portfolio"
            },
            portfolioCreation: {
                administrativePortfolio: "Administrative",
                aladdinPortfolioTicker: "Aladdin Portfolio Ticker",
                analyticalPortfolio: "Shared",
                buildOption: "Select how you want to build your portfolio",
                currency: "Currency",
                description: "Description",
                grid: {
                    commitment: "Commitment",
                    commitmentDate: "Commitment Date",
                    customCommitment: "Custom Commitment",
                    fundCurrency: "Fund Currency",
                    fundName: "Fund Name",
                    fundSize: "Fund Size",
                    geography: "Geography",
                    investorAccount: "Investor Account",
                    investorCurrency: "Investor Currency",
                    manager: "Manager",
                    strategy: "Strategy",
                    vintage: "Vintage"
                },
                manualComposition: "Manual Composition",
                portfolioCreationManualComposition: {
                    addAssets: "Please add assets",
                    addFunds: "Add Funds",
                    addInvestorAccountAction: "Add Investor Account",
                    removeAll: "Remove All"
                },
                portfolioDeletion: {
                    deletePortfolio: "Delete Portfolio",
                    deletePortfolioAlertFirstLine: "Selected portfolios will be deleted. This action can not be reversed.",
                    deletePortfolioAlertHeader: "Delete Selected Portfolios?"
                },
                portfolioName: "Portfolio Name",
                portfolioTagCreation: {
                    apply: "Apply",
                    assignTagAction: "Assign Tag",
                    assignTagActionHeader: "Assign Tags",
                    createTagButton: "Create New Tag",
                    dialogConfirm: "Create",
                    dialogEditConfirm: "Save",
                    selectColor: "Select Color",
                    tag: "Tag",
                    tagColor: "Tag Color",
                    tagName: "Tag Name"
                },
                portfolioType: "Portfolio Type",
                privatePortfolio: "Visible Only to Me",
                rulesBased: "Rules-based on Investor Accounts",
                rulesBasedOnFunds: "Rules-based on Funds",
                rulesBasedOnFundsWarning: "Rules-based on Funds Portfolios are visible only in Insight. They will not be synchronized with other Aladdin systems.",
                rulesBasedOnInvestorWarning: "Portfolio created with these selection of filters will be visible only in Insight. They will not be synchronized with other Aladdin systems.",
                startDate: "Start Date",
                title: "Create Portfolio",
                titleEdit: "Edit Portfolio",
                userGroup: "User Group"
            },
            portfolioEdition: {
                assets: "Assets",
                confirmationPrompt: {
                    confirmation: "Confirmation",
                    firstLine: (step) => `Are you sure you want to switch to ${step === 2 ? "Rules-based" : "Manual Composition"} ?`,
                    secondLine: "Current selection will be lost."
                },
                notSynchronizedWithCentral: "Not synchronized with other Aladdin systems.",
                overview: "Overview",
                porfolioBasedOn: (step) => {
                    switch (step) {
                        case 0:
                            return "Rules-based on Investor.";
                        case 1:
                            return "Rules-based on Funds.";
                        default:
                            return "Manual Composition.";
                    }
                },
                switchTo: (step) => `Switch to ${step === 2 ? "Rules-based" : "Manual Composition"}`,
                synchronizedWithCentral: "Synchronized with other Aladdin systems."
            },
            privateBenchmarkSelection: {
                benchmark: "Benchmark: ",
                defaultBenchmark: "Default Benchmark: ",
                fundData: "and Fund Data:",
                noSelectedText: "No Benchmark Selected.",
                notificationMessage: (entityName) => `Selected Benchmark will apply only to ${entityName}`,
                selectLinkText: "Select a Benchmark",
                title: "Select Benchmark"
            },
            publicMarketIndicesSelection: {
                footer: "Select up to 10 Public Indices",
                footerWarning: "The maximum number of selected Public Indices is reached",
                headers: {
                    currency: "Currency",
                    index: "Index name",
                    ticker: "Ticker",
                    type: "Type"
                },
                notificationMessage: (entityName) => `Selected Public Indices will apply only to ${entityName}`,
                shortType: {
                    default: "Default",
                    managed: "Managed"
                },
                title: "Select Public Indices"
            },
            renameAnalysis: "Rename Analysis",
            renamePage: "Rename Page",
            renameSection: "Rename Section",
            settings: {
                calculationSettings: {
                    allocationKey: {
                        allocationChangeNote: `Note: Change the allocation calculation on the figures displayed on Insight. 
                    Net NAV scaling will fall back on the Gross NAV if the Net NAV value is not reported.`,
                        label: "Allocation key",
                        units: {
                            commitmentBased: "Commitment based",
                            grossNavBased: "Gross NAV based",
                            hybridGrossBased: "Gross NAV based for Unrealized, Commitment based for Realized",
                            hybridNetBased: "Net NAV based for Unrealized, Commitment based for Realized",
                            netNavBased: "Net NAV based"
                        }
                    },
                    commitmentCalculation: {
                        commitmentCalculationNote: "Note: Change the commitment calculation on the figures displayed on Insight.",
                        commitmentDescription: {
                            historicalCommitment: "When a commitment needs to be converted, the system will convert the commitment amount from" +
                                " the reported data in fund currency into the target currency as of the analysis date.",
                            recomputedCommitment: "When a commitment needs to be converted, the system will add the funded amounts to the" +
                                " remaining commitment to recompute the initial commitment amount. "
                        },
                        label: "Commitment Calculation",
                        units: {
                            historicalCommitment: "Historical Commitment",
                            recomputedCommitment: "Recomputed Commitment"
                        }
                    },
                    label: "User Calculation Settings",
                    sustainability: {
                        label: "Sustainability",
                        sustainabilityNote: "Note: Change what data is displayed when GP reported data as of date is not available.",
                        units: {
                            clarityEstimates: "Clarity estimates",
                            gpReportedDataFromYearBefore: "GP reported data from year before"
                        }
                    }
                },
                numbersAndDateFormat: {
                    dateFormat: "Date format",
                    example: "Example",
                    label: "Numbers & Date Format",
                    negativeNumber: "Negative number",
                    preview: {
                        date: "Date",
                        negativeNumber: "Negative number",
                        shortFormat: "Short format",
                        standardFormat: "Standard format"
                    },
                    region: "Region"
                },
                templateManagement: {
                    enableJSONEditing: "Enable JSON editing",
                    label: "Layout Settings",
                    resetDefaultLayouts: "Unhide default layout",
                    resetLayouts: "Unhide layouts",
                    widgets: "Widgets"
                },
                unitOfAreaSettings: {
                    label: "Unit of Area",
                    units: {
                        acre: "Acre",
                        hectare: "Hectare",
                        squareFoot: "Square foot",
                        squareMeter: "Square meter"
                    }
                }
            },
            shareAnalysis: "Share Analysis",
            unSavedChanges: {
                cancel: "Cancel",
                discard: "Discard",
                save: "Save"
            },
            widgetWorkshop: {
                applyAsDefault: "Apply as default",
                columnSection: {
                    groupColumns: "Group Columns",
                    remove: "Remove"
                },
                data: "Data",
                dataOptions: {
                    againstGrandTotal: "Against grand total",
                    againstGroups: "Against groups",
                    collapsed: "Collapsed",
                    columnName: "Column name",
                    currentPeriod: "Current period",
                    dimensionName: "Dimension name",
                    displayAsVariation: "Display as variation",
                    displayGroupAs: "Display group as",
                    displayOptions: "Display options",
                    enableVariationGrouping: "Enable variation grouping",
                    expanded: "Expanded",
                    groupName: "Group name",
                    measureName: "Measure name",
                    none: "None",
                    pinColumn: "Pin column",
                    pinLeft: "Pin left",
                    pinRight: "Pin right",
                    pmi: (index) => `Index ${index}`,
                    pmiOptions: "Public Indices options",
                    previousPeriod: "Previous period",
                    ratingOptions: "Rating options",
                    relativeValueOption: "Relative value",
                    showHideRating: "Show/Hide Rating",
                    showVariationOption: "Show variation option",
                    variation: "Variation",
                    variationPercent: "Variation (%)"
                },
                dataset: "Dataset",
                detailsPanel: {
                    addColumn: "Add Column",
                    addGroupingOptions: "Add Grouping Options",
                    columns: "Columns",
                    customize: "Customize",
                    datapoints: "Datapoints",
                    dimension: "Dimension",
                    doubleClickMessage: "Double-click on datapoint to add",
                    gotIt: "Got it",
                    mainColumn: "Main Column",
                    measure: "Measure",
                    options: "Options",
                    pivotTable: "Pivot Table",
                    selectDimension: "Select dimension",
                    selectMainColumn: "Select Main Column",
                    selectMeasure: "Select measure",
                    simpleTable: "Simple Table",
                    tableStyle: "Table style",
                    ungroup: "Ungroup"
                },
                dimensions: "Dimensions",
                entityType: {
                    asset: "Asset",
                    fund: "Fund",
                    instrument: "Instrument",
                    investorAccount: "Investor Account",
                    portfolio: "Portfolio"
                },
                filtering: "Filtering",
                measureNames: {
                    assetName: "Asset Name",
                    fundName: "Fund Name",
                    instrumentName: "Instrument",
                    investorName: "Investor Name"
                },
                measures: "Measures",
                name: "Widget name",
                namePlaceholder: "Enter name here",
                period: "Period",
                previewSectionDefaultMessage: "You have not added any columns yet.",
                relativeValueOption: "Relative value",
                settings: "Settings",
                settingsContent: {
                    comparisonSetting: {
                        header: "Portfolio Comparison",
                        toggle: "Toggle"
                    },
                    grandTotalSetting: {
                        header: "Grand Total",
                        showOnColumns: "Display on Columns"
                    },
                    kpiAdditionalDisplayOption: {
                        header: "Additional Display Option",
                        showHistory: "Show History",
                        variationPeriod: "Variation Period"
                    },
                    soldAssetsSetting: {
                        excludeSoldAssets: "Exclude Sold Assets",
                        header: "Sold Assets"
                    },
                    stackingSettings: {
                        header: "Style",
                        unstack: "Unstacked"
                    },
                    totalRowsSetting: {
                        header: "Total Row Count",
                        showOnColumns: "Display Total Row Count"
                    }
                },
                type: {
                    bar: "Bar",
                    donut: "Donut",
                    grid: "Grid",
                    kpi: "KPI",
                    surface: "Surface",
                    timeSeries: "Time Series",
                    valuePair: "Value Pair"
                },
                widgetTypeNotSelected: "You have not selected any widget type."
            }
        },
        multiColumnSort: {
            addSort: "Add Sort",
            clearAll: "Clear All",
            selectReorderAndAdd: "Select, Reorder, and Add",
            sortOrder: "Sort Order",
            then: "then"
        },
        newAnalysis: "New Analysis",
        newPage: "New Page",
        notes: {
            activeUploadsDialog: {
                details: "Upload will be canceled if you leave.",
                message: "Document upload in progress.",
                title: "Active Upload"
            },
            activeUploadsWarning: "Document upload in progress. Upload will be canceled if you leave.",
            category: "Category",
            createNoteButtonLabel: "Create New Note",
            deletion: {
                cannotBeUndone: "This can not be undone.",
                deleteMessage: (noteTitle) => `Are you sure you want to delete "${noteTitle}"?`,
                deleteNote: "Delete Note",
                noteTitle: "Note Title"
            },
            documents: {
                cancel: "Cancel Upload",
                delete: "Remove File",
                download: "Download File",
                uploadFailed: (documentName) => `Document ${documentName} not uploaded. Error`,
                uploadFailedConfigError: "Vault tenant is not configured properly. File upload is unavailable",
                uploadSuccess: (documentName) => `Document ${documentName} has been successfully uploaded.`
            },
            emptyNoteList: "There are no notes to display.",
            leftPanel: {
                createNewNoteBtnLabel: "+ Create New Note",
                header: "Notes"
            },
            mainContent: {
                imagePasteBlocked: "Notes currently do not support images",
                noteEditorLabel: "Note",
                titleRowLabel: "Title"
            },
            noCategory: "No Category",
            rightPanel: {
                details: "Details",
                files: "Files",
                metaData: "Metadata",
                referenceDate: "Reference Date",
                uploadFiles: "Upload Files",
                uploadFilesDisabledNoConfig: "Additional configuration needed",
                uploadFilesDisabledNotSaved: "Please save note first"
            },
            saveNotificationMessage: {
                createFailed: "Failed to create note",
                createSuccess: "New Note saved successfully",
                editFailed: "Failed to update note",
                editSuccess: "Note updated successfully",
                pending: "Saving note..."
            },
            unSavedChangesDialogMessages: {
                details: "Do you want to save your changes before leaving?",
                message: "You have unsaved changes.",
                title: "Unsaved Changes"
            }
        },
        notifications: {
            modal: {
                updateReadersMessage: "? This action can not be reversed.",
                updateReadersTitle: "Delete Selected Objective?"
            },
            validationErrorDialog: {
                title: "Notification Errors"
            }
        },
        portfolios: {
            gridTitle: "Portfolios"
        },
        preferences: {
            saveUserPreferencesNotificationMessage: {
                editFailed: "Failed to update preferences",
                editSuccess: "Preferences updated successfully",
                pending: "Saving preferences..."
            }
        },
        privateBenchmarks: {
            Blended: "Blended",
            RuleBased: "Rule-based",
            Standard: "Standard",
            Uploaded: "Uploaded"
        },
        quarterPicker: {
            day: "Day",
            header: "Pick a quarter",
            q1: "Q1",
            q2: "Q2",
            q3: "Q3",
            q4: "Q4",
            quarter: "Quarter"
        },
        skeleton: {
            appName: "Insight",
            dialogMessages: "Messages",
            mainContentText: "Main Content",
            navigation: {
                account: "Account",
                administration: {
                    addTemplate: "Add Model",
                    administration: "Administration",
                    applyByFund: "Apply by Fund",
                    applyByStrategy: "Apply by Strategy",
                    applyModels: "Apply Models",
                    cashflowForecasting: "Cashflow Forecasting",
                    customModels: "Custom Models",
                    data: "Data",
                    downloadTemplate: "Download Template",
                    fundSpecificTemplate: "Fund-specific Template",
                    generalTemplate: "General Template",
                    investmentEntitiesAdministration: "Investment entities administration",
                    marketData: "Market Data",
                    marketDataAdministration: "Market data administration",
                    modelConfiguration: "Model Configuration",
                    predefinedModels: "Predefined Models",
                    systemAdministration: "System administration",
                    taModels: "Predefined Models",
                    whatToUpload: "Not sure what to upload?"
                },
                allocationPacing: "Allocation & Pacing",
                assets: "Assets",
                campaigns: "Campaigns",
                customIndices: "Custom Indices",
                dashboard: "Analysis",
                documentService: "Documents",
                fundSeries: "Fund Series",
                funds: "Funds",
                home: "Home",
                idd: "Investment Due Diligence",
                jCurves: "J-Curves",
                managers: "Managers",
                marketMap: "Market Map",
                markets: "Research",
                notifications: "Notifications",
                options: "Options",
                pacingPlans: "Pacing Plans",
                peerComparison: "Peer Investor Comparison",
                permissions: "Permissions",
                portfolios: "Portfolios",
                preqinBanner: {
                    text: "Explore Pre-Investment Solutions",
                    tooltip: "Download a one pager detailing our new pre-investment solutions in eFront Insight."
                },
                previousVersion: "Open Previous Version",
                previousVersionPopover: "Open previous version of Insight in new tab",
                settings: "Settings",
                sourcingDiligence: "Sourcing & Diligence",
                syncInProgress: "Data synchronization in progress"
            },
            notificationsMenu: {
                clearAllFinished: "Clear All Finished",
                dataSynchronisationInProgress: (time, progress) => {
                    let progressText = "";
                    if (progress !== null && progress !== undefined) {
                        progressText = ` – ${Math.round(progress * 100)}% complete`;
                    }
                    return `Updating Data${progressText} (${time})`;
                },
                dataSynchronisedDate: (time) => `Data Updated as of ${time}`,
                goToPage: "Go To Page",
                notifications: "Notifications"
            },
            settingsMenu: {
                calculationPeriod: "Calculation Period",
                calculationPeriodLabel: "Defines the historical period used to calculate performance metrics such as IRR and TWR.",
                chartType: {
                    barChart: "Horizontal Bars",
                    donut: "Donut",
                    lineChart: "Line Chart",
                    stackedBars: "Stacked Bars",
                    treeMapChart: "Surface"
                },
                dataScale: {
                    billion: "Billion",
                    labelScale: "Scale",
                    million: "Million",
                    unit: "Unit"
                },
                displayOptions: {
                    display: "Display",
                    displayRowTotal: "Display Total Row Count",
                    displayTotals: "Display Totals",
                    rowNumber: "Display Row Number",
                    scale: "Scale",
                    totals: "Totals"
                },
                displayValueType: "Display values in %",
                excludeSoldAssets: "Exclude Sold Assets",
                granularity: {
                    granularity: "Data Granularity",
                    granularityLabel: "Determines how data is aggregated and displayed over time (e.g., quarterly or yearly). It does not impact any calculations.",
                    period: "Variation Period",
                    quarterly: "Quarterly",
                    yearOverYear: "Year Over Year",
                    yearly: "Yearly",
                    ytd: "Year To Date"
                },
                periodOfAnalysis: {
                    itd: "Inception To Date",
                    lastFiveYears: "Last 5 Years",
                    lastSixMonths: "Last 6 Months",
                    lastTenYears: "Last 10 Years",
                    lastThreeMonths: "Last 3 Months",
                    lastThreeYears: "Last 3 Years",
                    lastTwelveMonths: "Last 12 Months",
                    periodOfAnalysis: "Period of Analysis",
                    ytd: "Year To Date"
                },
                settings: "Settings",
                shownValues: {
                    all: "All",
                    biggerThan: "All items bigger than",
                    bottom10: "Bottom 10",
                    bottom5: "Bottom 5",
                    label: "Show",
                    others: "Others",
                    top10: "Top 10",
                    top5: "Top 5"
                },
                sort: {
                    name: "Name",
                    sortBy: "Sort by",
                    value: "Value"
                },
                tenorOptions: {
                    Itd: "Inception To Date",
                    ItdShort: "ITD",
                    Ytd: "Year To Date",
                    YtdShort: "YTD",
                    customDateRange: "Custom Date Range",
                    endDate: "End Date",
                    fiveYears: "5 Years",
                    oneMonth: "1 Month",
                    oneQuarter: "1 Quarter",
                    oneYear: "1 Year",
                    sixMonths: "6 Months",
                    startDate: "Start Date",
                    tenYears: "10 Years",
                    threeYears: "3 Years",
                    twoYears: "2 Years"
                },
                timePeriodLabel: "Controls the reporting window of the displayed data in widgets. It does not impact any underlying calculations, except for Variation widgets, Total Value, and the Value Bridge.",
                timeperiod: "Time Period",
                viewForm: {
                    amount: "Amount",
                    multiple: "Multiple",
                    percent: "Percentage",
                    viewForm: "View Form"
                }
            },
            userAccountMenu: {
                account: "Account",
                allocationKey: "Allocation key",
                commitmentBased: "Commitment based",
                grossNavBased: "Gross NAV based",
                hybridGrossBased: "Gross NAV based for Unrealized, Commitment based for Realized",
                hybridNetBased: "Net NAV based for Unrealized, Commitment based for Realized",
                logout: "Logout",
                netNavBased: "Net NAV based"
            }
        },
        smartFilter: {
            error0: "Something went wrong. Please try again later.",
            error1: "No filters matched your input. Try rephrasing or checking for typos.",
            panelHeader: "Suggested prompts",
            successMessage: "Your filters have been applied"
        },
        table: {
            companyType: "Company Type",
            country: "Country",
            currentPeriod: "Current period",
            currentRating: "Current Rating",
            dataPoints: {
                enterpriseValueVariation: "Enterprise Value",
                ltmRevenueVariation: "LTM Revenue",
                ltmebitdaVariation: "LTM EBITDA",
                netDebtVariation: "Net Debt"
            },
            geography: "Geography",
            industries: "Industries",
            industryGroups: "Industry Groups",
            investmentStatus: "Investment Status",
            investmentYear: "Investment year",
            previousPeriod: "Previous period",
            previousRating: "Previous Rating",
            quarter: "Quarter",
            rating: "Rating",
            sector: "Sector",
            variation: "Variation",
            variationPeriod: "Variation period"
        },
        widget: {
            allInCurrency: (currency) => `All in ${currency}.`,
            dataSelect: {
                groups: {
                    assetLevel: "Underlying asset",
                    fundLevel: "Fund"
                }
            },
            defaultBenchmarkLabel: "Default ",
            difference: "Difference",
            editConfig: "Edit config",
            error: "Sorry! Something went wrong. Please try again.",
            errorMessage: "Technical problem. Contact your administrator.",
            errorWidgetTitle: "Error displaying title",
            footer: {
                dateRange: (startDate, endDate) => `Showing from ${startDate} to ${endDate}.`,
                inceptionDateRange: "Showing Inception to Date.",
                periodOfAnalysis: (periodLabel) => `Period of analysis: ${periodLabel}`
            },
            inspectData: "Inspect Data",
            inspectDataDetails: "Inspect Data Details",
            inspectDataExport: "Export Data to Excel",
            loading: "Loading...",
            maximize: "Maximize",
            minimize: "Minimize",
            more: "More",
            multiples: "Multiples",
            noComparisonPortfolio: "Please select a comparison portfolio",
            notActualData: "Some figures are not actual or reported.",
            settings: "Personal Settings",
            variation: "% Variation of "
        },
        widgets: {
            esgNews: {
                environmental: "Environmental",
                governance: "Governance",
                social: "Social"
            },
            esgRating: {
                noChangeSinceLastQuarter: "No change since last qtr.",
                previousQuarter: "previous quarter"
            },
            freeText: {
                iconTitle: "Edit comment",
                initialText: "Enter your comment...",
                invalidComment: "Invalid comment"
            },
            kpi: {
                gainLossIndicatorQtr: "since last qtr.",
                gainLossIndicatorYear: "since last year",
                gainLossIndicatorYearOverYear: "over the past year",
                noChange: "No change"
            },
            principlesTable: {
                antiCorruption: "Anti-Corruption",
                description: "Description",
                descriptions: {
                    principle1: "Businesses should support and respect the protection of internationally proclaimed human rights.",
                    principle10: "Businesses should work against corruption in all its forms, including extortion and bribery.",
                    principle2: "Make sure that they are not complicit in human rights abuses.",
                    principle3: "Businesses should uphold the freedom of association and the effective recognition of the right to collective bargaining.",
                    principle4: "The elimination of all forms of forced and compulsory labour.",
                    principle5: "The effective abolition of child labour.",
                    principle6: "The elimination of discrimination in respect of employment and occupation.",
                    principle7: "Businesses should support a precautionary approach to environmental challenges.",
                    principle8: "Undertake initiatives to promote greater environmental responsibility.",
                    principle9: "Encourage the development and diffusion of environmentally friendly technologies."
                },
                endDate: "End Date",
                environment: "Environment",
                humanRights: "Human Rights",
                labour: "Labour",
                noViolation: "No violation",
                operations: "Operations",
                potential: "Potential",
                potentialViolation: "Potential violation",
                principle: "Principle",
                principles: "Principles",
                sourceOfViolation: "Source of violation",
                startDate: "Start Date",
                stillActive: "still active",
                supplyChain: "Supply Chain",
                violation: "Violation",
                violationSource: "Source of violation",
                violationType: "Type",
                violator: "Violator"
            },
            quartileRanking: {
                bottom: "Bottom",
                dpi: "DPI",
                dpiRanking: "DPI Ranking",
                irrRanking: "IRR Ranking",
                lowerMid: "Lower Mid",
                netIrr: "Net IRR",
                picc: "PICC",
                piccRanking: "PICC Ranking",
                top: "Top",
                tvpi: "TVPI",
                tvpiRanking: "TVPI Ranking",
                unknownn: "N/A",
                upperMid: "Upper Mid"
            },
            unitOfAreaAbbreviations: {
                other: "Other",
                squareFoot: "Sq. Feet",
                squareMeter: "Sq. Meter"
            }
        },
        workspace: {
            createWorkspaceLabel: "Create New Workspace",
            deleteHeader: "Delete Workspace?",
            deleteLabel: "Delete",
            deleteMessage: (workspace) => `Are you sure you want to delete the workspace "${workspace}"?`,
            duplicateLabel: "Duplicate",
            duplicateWorkspaceLabel: "Duplicate Workspace",
            editWorkspaceLabel: "Workspace Settings",
            errorMsg: "There was an error loading the workspaces data. Please try refreshing your browser window.",
            headerCreatedBy: "Created By",
            headerDefault: "Default",
            headerPrivacy: "Privacy",
            headerUpdatedBy: "Updated By",
            headerUpdatedOn: "Updated On",
            headerVisibility: "Visibility",
            headerWorkspaceName: "Workspace Name",
            manageWorkspaceLabel: "Manage Workspace List",
            placeHolderText: "Enter Workspace Name",
            private: "Visible Only to Me",
            privateDescription: "Only I can view and edit this workspace.",
            public: "Public",
            publicDescription: "Anyone in your organization can view and edit this workspace.",
            setDefaultLable: "Set as default",
            settingsLabel: "Settings",
            workspaceDisabledMessage: "Additional subscription required.",
            workspaceLabel: "Workspace",
            workspaceNameLabel: "Workspace Name",
            workspacePrivacyLabel: "Workspace Privacy"
        }
    }
};
export const appInsightEvents = {
    customEvents: {
        names: {
            AddAnalysis: "AddAnalysisButtonClicked",
            AddNewModelCFFAdministration: "AddNewModelCFFAdministration",
            AdministrationSectionOpened: "OpenSectionInAdministration",
            AnalyticsCopilotAddToDashboard: "AnalyticsCopilotAddToDashboard",
            AnalyticsCopilotClickSuggestedQuestion: "AnalyticsCopilotClickSuggestedQuestion",
            AnalyticsCopilotDownloadAsExcel: "AnalyticsCopilotDownloadAsExcel",
            AnalyticsCopilotSendMessage: "AnalyticsCopilotSendMessage",
            AnalyticsCopilotStartSession: "AnalyticsCopilotStartSession",
            ApplicationBackButton: "ApplicationBackButtonClicked",
            BenchmarkAssignment: "BenchmarkAssignment",
            BenchmarkExportSelection: "ExportInsightResearchBenchmark",
            BenchmarkExportSelectionDetail: "ExportInsightResearchBenchmarkDetails",
            BenchmarkWidgetNavigation: "BenchmarkWidgetNavigation",
            BlendedBenchmarkGridClicked: "BlendedBenchmarkGridClicked",
            BrowserBackButton: "BrowserBackButtonClicked",
            CampaignDownload: "CampaignDownload",
            CampaignNavigation: "CampaignNavigation",
            CampaignQuarterChange: "CampaignQuarterChange",
            CampaignSelection: "CampaignSelection",
            ChangeAsOfDate: "ChangeAsOfDate",
            ChangeDashboardDataGranularity: "ChangeDashboardDataGranularity",
            ChangeDashboardTimePeriod: "ChangeDashboardTimePeriod",
            ChangeDefaultWorkspace: "ChangeDefaultWorkspace",
            ChangeWidgetSettingsDataGranularity: "ChangeWidgetSettingsDataGranularity",
            ChangeWidgetSettingsDisplayAs: "ChangeWidgetSettingsDisplayAs",
            ChangeWidgetSettingsDisplayAsPercent: "ChangeWidgetSettingsDisplayAsPercent",
            ChangeWidgetSettingsShowSubset: "ChangeWidgetSettingsShowSubset",
            ChangeWidgetSettingsSorting: "ChangeWidgetSettingsSorting",
            ChangeWidgetSettingsVariationPeriod: "ChangeWidgetSettingsVariationPeriod",
            ChangeWidgetSettingsWidgetType: "ChangeWidgetSettingsWidgetType",
            ChangeWidgetView: "ChangeWidgetView",
            ChangeWorkspaceVisibility: "ChangeWorkspaceVisibility",
            ClickedCommitmentPacing: "ClickedCommitmentPacing",
            ClickedOnBenchmarkAssignment: "ClickedOnBenchmarkAssignment",
            ClickedOnPreqinLink: "ClickedOnPreqinLink",
            ClickthroughLinkClicked: "ClickthroughLinkClicked",
            ClickthroughPageOpened: "ClickthroughPageOpened",
            CommitmentPacingCalculationLaunched: "CommitmentPacingCalculationLaunched",
            CommitmentPacingModelSaved: "CommitmentPacingModelSaved",
            CommitmentPacingModelSavedAs: "CommitmentPacingModelSavedAs",
            CreateBlendedBenchmark: "CreateBlendedBenchmark",
            CreateBlendedBenchmarkOpenModal: "CreateBlendedBenchmarkOpenModal",
            CreatePortfolio: "CreatePortfolio",
            CreatePortfolioAddFunds: "CreatePortfolioAddFunds",
            CreatePortfolioAddInvestorAccounts: "CreatePortfolioAddInvestorAccounts",
            CreatePortfolioChangeScaling: "CreatePortfolioChangeScaling",
            CreatePortfolioCompositionRules: "CreatePortfolioCompositionRules",
            CreatePortfolioManualComposition: "CreatePortfolioManualComposition",
            CreatePortfolioOpenModal: "CreatePortfolioOpenModal",
            CreateUserDefinedBenchmark: "CreateUserDefinedBenchmark",
            CreateUserDefinedBenchmarkOpenModal: "CreateUserDefinedBenchmarkOpenModal",
            CreateWorkspace: "CreateWorkspace",
            DashboardLevelFilter: "DashboardFilterAdded",
            DefaultBenchmarkGridClicked: "DefaultBenchmarkGridClicked",
            DefaultWorkspaceClicked: "DefaultWorkspaceClicked",
            DeleteAnalysis: "DeleteAnalysisButtonClicked",
            DeleteWorkspace: "DeleteWorkspace",
            DocumentLibraryClearFilters: "DocumentLibraryClearFilters",
            DocumentLibraryDownload: "DocumentLibraryDownload",
            DocumentLibraryExportToExcel: "DocumentLibraryExportToExcel",
            DocumentLibraryFilterApplied: "DocumentLibraryFilterApplied",
            DocumentLibraryPageOpened: "DocumentLibraryPageOpened",
            DocumentLibrarySortChanged: "DocumentLibrarySortChanged",
            DownloadBenchmarkTemplate: "DownloadBenchmarkTemplate",
            DuplicateWorkspace: "DuplicateWorkspace",
            EditWorkspace: "EditWorkspace",
            ExportCustomBenchmark: "ExportCustomBenchmark",
            ExportCustomBenchmarkDetails: "ExportCustomBenchmarkDetails",
            ExportDataSetFromDashboard: "ExportDataSetFromDashboard",
            ExportEntitySelection: "OpenEntityInExport",
            ExportPDFFullAnalysis: "ExportPDFFullAnalysis",
            ImportCustomBenchmark: "ImportCustomBenchmark",
            LayoutDeletion: "LayoutDeletion",
            MarketDataAdministrationSectionChanged: "OpenSectionInMktDataAdministration",
            NavigationFromGrid: "NavigationFromGrid",
            NavigationFromMainGrid: "NavigationFromMainGrid",
            NavigationInMarketDataMenu: "NavigationInMarketDataMenu",
            NavigationMainGrids: "NavigationMainGrids",
            NotesCreateNote: "NotesCreateNote",
            NotesDeleteDocument: "NotesDeleteDocument",
            NotesDeleteNote: "NotesDeleteNote",
            NotesDownloadDocument: "NotesDownloadDocument",
            NotesNavigateNote: "NotesNavigateNote",
            NotesPageOpened: "NotesPageOpened",
            NotesSaveNote: "NotesSaveNote",
            NotesUploadDocument: "NotesUploadDocument",
            OpenBenchmarkDetails: "OpenBenchmarkDetails",
            OpenExportDataScreen: "OpenExportDataScreen",
            OpenExportHistory: "OpenExportHistory",
            OpenImportDataScreen: "OpenImportDataScreen",
            OpenInspectData: "OpenInspectData",
            OpenPreviousVersion: "OpenPreviousVersionLinkClicked",
            OpenSection: "OpenSectionInAnalysisClicked",
            PortfolioDeletion: "PortfolioDeletion",
            PreqinBenchmarkLinkClicked: "PreqinBenchmarkLinkClicked",
            PrivateEquityBenchmarkTabSwitch: "SwitchTabDefaultAndCustom",
            RawTemplateExport: "RawTemplateExport",
            RawTemplateImport: "RawTemplateImport",
            ResetDashboardDateSettings: "ResetDashboardDateSettings",
            SaveAnalysis: "SaveAnalysisButtonClicked",
            SaveModelAssignment: "SaveModelAssignment",
            SaveWorkspaceList: "SaveWorkspaceList",
            UserDefinedBenchmarkGridClicked: "UserDefinedBenchmarkGridClicked",
            WidgetExportToExcel: "WidgetExportToExcelClicked",
            WidgetExportToPDF: "WidgetExportToPDFClicked",
            WidgetGridExportToExcel: "WidgetGridExportToExcelClicked",
            WidgetLevelFilter: "WidgetFilterAdded"
        }
    }
};
